import Component from '@glimmer/component';
import { service } from '@ember/service';
import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { HdsTabs } from '@hashicorp/design-system-components/components';
import {
  CONTENT_TABS_LABELS,
  PRODUCT_POWERSHELL,
  PRODUCT_AZURE_CLI,
  PRODUCT_BASH,
} from 'networks-common/utils/content-tabs';
import {
  isActivePeering,
  isPendingAcceptance,
} from 'networks-common/utils/peerings';
import Terraform from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/code-snippets/terraform';
import CloudShell from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/cloud-shell';
import UpdatingSecurityGroups from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/updating-security-groups';

export default class PageHvnPeeringsDetailContentTabsAzure extends Component {
  @service router;

  tabs = CONTENT_TABS_LABELS;
  products = {
    powershell: PRODUCT_POWERSHELL,
    azurecli: PRODUCT_AZURE_CLI,
    bash: PRODUCT_BASH,
  };

  updateQueryParams = (queryParams = {}) => {
    return this.router.transitionTo(this.router.currentRouteName, {
      queryParams,
    });
  };

  get isActive() {
    return isActivePeering(this.args.peering);
  }

  get isPending() {
    return isPendingAcceptance(this.args.peering);
  }

  get product() {
    return this.args.product;
  }
  <template>
    <div
      data-test-peering-content-tabs-azure
      class="hvnsPeeringsDetail__instructions--contentTabs"
    >
      {{#if this.isPending}}
        <HdsTabs as |T|>
          <T.Tab
            @icon="terraform-color"
            @isSelected={{eq @tab this.tabs.terraform.id}}
            data-test-peering-terraform-tab-azure
            {{on
              "click"
              (fn this.updateQueryParams (hash tab=this.tabs.terraform.id))
            }}
          >
            {{t this.tabs.terraform.label}}
          </T.Tab>
          <T.Panel />

          {{!-- <T.Tab
        @isSelected={{eq @tab this.tabs.terminal.id}}
        {{on
          'click'
          (fn this.updateQueryParams (hash tab=this.tabs.terminal.id))
        }}
        data-test-peering-terminal-tab-azure
      >
        {{t this.tabs.terminal.label}}
      </T.Tab>
      <T.Panel /> --}}

          <T.Tab
            @isSelected={{eq @tab this.tabs.cloudShell.id}}
            data-test-peering-cloud-shell-tab-azure-cloud-shell
            {{on
              "click"
              (fn
                this.updateQueryParams
                (hash tab=this.tabs.cloudShell.id product=this.products.bash.id)
              )
            }}
          >
            {{t this.tabs.cloudShell.label}}
          </T.Tab>
          <T.Panel />

          {{! Commenting out Web console tab per https://hashicorp.atlassian.net/browse/TCE-2005  }}
          {{!-- <T.Tab
        @isSelected={{eq @tab this.tabs.webConsole.id}}
        {{on
          'click'
          (fn this.updateQueryParams (hash tab=this.tabs.webConsole.id))
        }}
        data-test-peering-web-console-tab-azure
      >
        {{t this.tabs.webConsole.label}}
      </T.Tab>
      <T.Panel /> --}}
        </HdsTabs>

        {{#if (eq @tab this.tabs.terraform.id)}}
          <Terraform @model={{@model}} />
          {{!-- {{else if (eq @tab this.tabs.terminal.id)}}
      <div {{box-padding '0 0 lg 0'}}>
        <div {{box-padding 'md 0 md 0'}}>
          {{t
            'components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.terminal.instructions'
          }}
        </div>
        <Disclosure
          data-test-peerings-content-tabs-terraform-azure-disclosure
          @label={{
            t
            'components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.disclosure.label'
          }}
        >
          <Page::HvnPeerings::Detail::ContentTabs::Azure::CompletionSteps />
        </Disclosure>
      </div>

      <Hds::Tabs as |T|>
        <T.Tab
          @isSelected={{eq @product this.products.powershell.id}}
          {{on
            'click'
            (fn this.updateQueryParams (hash product=this.products.powershell.id))
          }}
          data-test-peering-powershell-tab-azure
        >
          {{t this.products.powershell.label}}
        </T.Tab>
        <T.Panel />

        <T.Tab
          @isSelected={{eq @product this.products.azurecli.id}}
          {{on
            'click'
            (fn this.updateQueryParams (hash product=this.products.azurecli.id))
          }}
          data-test-peering-azure-cli-tab-azure
        >
          {{t this.products.azurecli.label}}
        </T.Tab>
        <T.Panel />
      </Hds::Tabs>

      {{! TODO TCE-1640 - this is placeholder content }}
      <div {{box-padding 'md 0 0 0'}}>
        {{#if (eq @product this.products.powershell.id)}}
          {{! Powershell snippet}}
          <Page::HvnPeerings::Detail::ContentTabs::Azure::CodeSnippets::Powershell
            @model={{@model}}
          />
        {{else if (eq @product this.products.azurecli.id)}}
          {{! Azure CLI snippet}}
          <Page::HvnPeerings::Detail::ContentTabs::Azure::CodeSnippets::AzureCli
            @model={{@model}}
          />
        {{/if}}
      </div>
    {{else if (eq @tab this.tabs.webConsole.id)}}
      <Page::HvnPeerings::Detail::ContentTabs::Azure::CompletionSteps /> --}}
        {{else if (eq @tab this.tabs.cloudShell.id)}}
          <CloudShell
            @model={{@model}}
            @product={{@product}}
            @products={{this.products}}
          />
        {{/if}}
      {{else if this.isActive}}
        <UpdatingSecurityGroups
          @model={{@model}}
          @tab={{@tab}}
          @product={{@product}}
        />
      {{/if}}
    </div>
  </template>
}
